import { Dialog, DialogContent } from "@mui/material";
import { MprcDialogTitleClose } from "components/MprcDialogTitleClose";
import { MprcRequestIndicator } from "components/MprcRequestIndicator";
import * as React from "react";
import { useEffect, useState } from "react";

/////////////////////////////////////////////////////////////////////////////////////


interface IProps {
    title: string;
    onGetData: () => Promise<string>;
    onError?: (error: any) => void;
    onClose: () => void;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////

export const MprcTextViewer: React.FC<Props> = (props) => {

    const [text, setText] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const { title, onClose, onGetData, onError } = props;

    ///
    useEffect(() => {
        async function load() {
            try {
                var result = await onGetData();
                setText(result);
            }
            catch (e) {
                onError?.(e);
            }
            setLoading(false);
        }

        if (loading) load();
    }, [loading]);


    if (loading) {
        return <MprcRequestIndicator type="waiting" />;
    }

    if (text == null) {
        onClose();
        return null;
    }

    return (
        <Dialog
            open
            fullWidth
            maxWidth="md"
            onClose={onClose}
        >
            <MprcDialogTitleClose
                title={title}
                shrinkPadding
                onClose={onClose}
            />
            <DialogContent sx={{ height: "100vh", fontFamily: "monospace" }}>
                <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                    <pre dangerouslySetInnerHTML={{ __html: text! }} />
                </div>
            </DialogContent>
        </Dialog>
    );
};
